import React from 'react';
import { Box } from '@mui/material';
import UnavailableCard from '../UnavailableCard';
import inverter_unavailable from '../../../assets/animations/unavailable/inverter.gif';

const LoadPage = () => {
  return (
    <Box sx={{ pt: 2 }}>
      <UnavailableCard
        title="Load data unavailable"
        message="Load data is not ready yet. Please contact your system administrator for more details."
        image={inverter_unavailable}
      />
    </Box>
  )
}

export default LoadPage;
